import { ModelBase } from "./model-base";

export class ReferenceIntakeProfile extends ModelBase {

  id: number;
  name: string;
  isDefault: boolean;
  created: Date;
  updated: Date;
  kj: number;
  kcal: number;
  carbs: number;
  sugars: number;
  fat: number;
  sats: number;
  protein: number;
  fibre: number;
  sodium: number;

  constructor(s?: Partial<ReferenceIntakeProfile>) {
    super(s);

    if (s) {
      this.stringToDate("created");
      this.stringToDate("updated");
    }
  }
}
